import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {AddOrUpdateAttributeOptions} from "./options/add-or-update-attribute.options";
import {MatDialogRef} from "@angular/material/dialog";
import {DataResponse} from "../../../../network/service/data.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";

@Component({
  selector: 'app-add-or-update-attribute',
  standalone: false,
  templateUrl: './add-or-update-attribute.component.html',
  styleUrls: ['./add-or-update-attribute.component.scss']
})
export class AddOrUpdateAttributeComponent extends BaseComponent implements OnInit {
  addOrUpdateAttributeOptions = new AddOrUpdateAttributeOptions();
  code?: string;
  title?: string;
  order?: number;
  attributeTypeId?: string;

  constructor(injector: Injector, private matDialogRef: MatDialogRef<AddOrUpdateAttributeComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.code = this.addOrUpdateAttributeOptions.attribute.AttributeCode;
    this.title = this.addOrUpdateAttributeOptions.attribute.AttributeTitle;
    this.order = this.addOrUpdateAttributeOptions.attribute.Order;
    this.attributeTypeId = this.addOrUpdateAttributeOptions.attribute.AttributeTypeId;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    (this.addOrUpdateAttributeOptions.attribute.AttributeId !== undefined ? this.serviceApi.updateAttribute(this.addOrUpdateAttributeOptions.attribute.AttributeId, {
      AttributeCode: this.code,
      AttributeTitle: this.title,
      Order: this.order,
      AttributeTypeId: this.attributeTypeId
    }) : this.serviceApi.createAttribute({
      AttributeCode: this.code,
      AttributeTitle: this.title,
      Order: this.order,
      AttributeTypeId: this.attributeTypeId
    })).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.addOrUpdateAttributeOptions.onInsertOrUpdateFinished();
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
